@if (!isLoading) {
    <div>
        <form
            class="detail-page-card-body padded cerrix-control-sm form-group-styling"
            [formGroup]="parentForm"
            novalidate
        >
            <div class="detail-page-action-bar flex-action-bar">
                <div class="col-md-12 text-start">
                    @if (!permissions.readOnly) {
                        <button
                            data-uiid="thirdpartycontract-save"
                            class="btn btn-cerrix btm-sm"
                            (click)="save()"
                        >
                            <i class="fas fa-save"></i>
                            <span class="d-none d-lg-inline">{{ "contract.saveContract" | t }}</span>
                        </button>
                    }
                    <span data-uiid="thirdpartycontracts-lastsaved" class="date-edited">
                        {{ "contract.lastSave" | t: { date: (contract.DateModified | dateTimeFormat) } }}
                    </span>
                </div>
            </div>

            @if (thirdParty) {
                <div class="detail-page-summary">
                    <div class="row">
                        <div class="col-6">
                            <div class="property">
                                <b>Third party ID:</b> {{ thirdParty.Identifier }}
                            </div>
                            <div class="property"><b>Name:</b> {{ thirdParty.Name }}</div>
                            <div class="property">
                                <b>Next review date:</b>
                                {{ thirdParty.NextReviewDate | dateFormat }}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="property">
                                <b>Last review score:</b> {{ thirdParty.Score.Name }}
                            </div>
                            <div class="property">
                                <b>Reviewer:</b> {{ thirdParty.ReviewerNames }}
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div
                menuSystem
                [cerrixTab]="tab"
                class="thirdparty-screens"
                (changeEvent)="handleMenuItemClick($event)"
            >
                <div
                    menuItemId="menuItemContracts"
                    [attr.name]="'contract.menuContracts' | t"
                    menuicon="fas fa-handshake"
                    menusystemsubmenu
                >
                    <div
                        menuItemId="menuItemDetails"
                        [attr.name]="'contract.menuDetails' | t"
                        class="handshake"
                        menuicon="fas fa-info-circle"
                        menusystemitem
                    >
                        <div class="detail-page-card">
                            <div class="detail-page-card-title">{{ "contract.contractDetailsTitle" | t }}</div>
                            <div
                                class="detail-page-card-body padded cerrix-control-sm form-group-styling"
                            >
                                <div class="row">
                                    <div class="col-12 col-xl-6 left-block">
                                        <div class="row">
                                            <div class="form-group col">
                                                <cerrix-textfield
                                                    [fieldLabel]="'contract.contractNumberLabel' | t"
                                                    dataUiid="thirdpartycontractdetail-contractno"
                                                    identifier="thirdPartyContractNoInput"
                                                    formControlName="ContractNumber"
                                                    [placeholder]="'contract.requiredPlaceholder' | t"
                                                ></cerrix-textfield>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col">
                                                @if (services) {
                                                    <div>
                                                        <label for="services">{{ "contract.servicesLabel" | t }}</label>
                                                        <cerrix-select-tree
                                                            data-uiid="thirdpartycontractdetail-services"
                                                            [tree]="services"
                                                            formControlName="Services"
                                                            [multiselect]="true"
                                                            #servicesTree
                                                        >
                                                        </cerrix-select-tree>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="thirdPartyContractStatusSelect">{{
                                                    "contract.statusLabel" | t
                                                }}</label>
                                                @if (status) {
                                                    <ng-select
                                                        data-uiid="thirdpartycontractdetail-status"
                                                        id="thirdPartyContractStatusSelect"
                                                        name="thirdPartyContractStatusSelect"
                                                        formControlName="Status"
                                                        bindLabel="Name"
                                                        bindValue="Name"
                                                        [items]="status"
                                                    >
                                                    </ng-select>
                                                }
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="contractOwnerSelect">{{
                                                    "contract.contractOwnerLabel" | t
                                                }}</label>
                                                @if (contract) {
                                                    <cerrix-select
                                                        data-uiid="thirdpartycontractdetail-contractowner"
                                                        [getDataMethod]="contractOwnerRequest"
                                                        formControlName="ContractOwner"
                                                        id="ContractOwner"
                                                        [closeOnSelect]="true"
                                                    >
                                                    </cerrix-select>
                                                }
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="currencySelect">{{ "contract.currencyLabel" | t }}</label>
                                                <ng-select
                                                    data-uiid="thirdpartycontractdetail-currency"
                                                    id="currencySelect"
                                                    name="currencySelect"
                                                    formControlName="currencyCode"
                                                    [items]="sd.Currencies"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [closeOnSelect]="true"
                                                >
                                                </ng-select>
                                            </div>
                                            <div class="form-group col">
                                                <label for="thirdPartyContractValueInput">{{
                                                    "contract.contractedValueLabel" | t
                                                }}</label>
                                                <input
                                                    data-uiid="thirdpartycontractdetail-contractedvalue"
                                                    type="number"
                                                    class="form-control form-control-sm"
                                                    id="thirdPartyContractValueInput"
                                                    formControlName="ContractedValue"
                                                    name="thirdPartyContractValueInput"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="AnnualValue">{{ "contract.annualValueLabel" | t }}</label>
                                                <input
                                                    data-uiid="thirdpartycontractdetail-annualvalue"
                                                    type="number"
                                                    class="form-control form-control-sm"
                                                    id="AnnualValue"
                                                    formControlName="AnnualValue"
                                                    name="AnnualValue"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-xl-6 right-block">
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="SignatureDate">{{ "contract.signatureDateLabel" | t }}</label>
                                                <date-input
                                                    data-uiid="thirdpartycontractdetail-signaturedate"
                                                    id="SignatureDate"
                                                    formControlName="SignatureDate"
                                                ></date-input>
                                            </div>
                                            <div class="form-group col">
                                                <label for="StartDate">{{ "contract.startDateLabel" | t }}</label>
                                                <date-input
                                                    data-uiid="thirdpartycontractdetail-startdate"
                                                    id="StartDate"
                                                    formControlName="StartDate"
                                                ></date-input>
                                            </div>
                                            <div class="form-group col">
                                                <label for="EndDate">{{ "contract.endDateLabel" | t }}</label>
                                                <date-input
                                                    data-uiid="thirdpartycontractdetail-enddate"
                                                    id="EndDate"
                                                    formControlName="EndDate"
                                                ></date-input>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label for="termOfNoticeSelect">{{ "contract.termOfNoticeLabel" | t }}</label>
                                            <div class="form-group col">
                                                <input
                                                    data-uiid="thirdpartycontractdetail-termofnotice-quantity"
                                                    type="number"
                                                    class="form-control form-control-sm"
                                                    id="termOfNoticeQuantity"
                                                    formControlName="TermOfNoticeQuantity"
                                                    name="termOfNoticeQuantity"
                                                    [placeholder]="'contract.quantityPlaceholder' | t"
                                                />
                                            </div>
                                            <div class="form-group col">
                                                <ng-select
                                                    data-uiid="thirdpartycontractdetail-termofnotice-period"
                                                    id="termOfNoticePeriodSelect"
                                                    name="termOfNoticePeriodSelect"
                                                    formControlName="TermOfNoticePeriod"
                                                    bindLabel="label"
                                                    bindValue="value"
                                                    required="true"
                                                    [placeholder]="'contract.periodPlaceholder' | t"
                                                    [items]="termOfNoticePeriods"
                                                >
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="thirdPartyFrameworkContractInput">{{
                                                    "contract.frameworkContractLabel" | t
                                                }}</label>
                                                <cerrix-checkbox
                                                    data-uiid="thirdpartycontractdetail-frameworkcontract"
                                                    fontsize="0.9em"
                                                    formControlName="Framework"
                                                    name="thirdPartyFrameworkContractInput"
                                                ></cerrix-checkbox>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="form-group col">
                                                <label for="contractDocumentManager">{{
                                                    "contract.contractDocumentsLabel" | t
                                                }}</label>
                                                <document-manager-old
                                                    data-uiid="thirdpartycontractdetail-contractdocuments"
                                                    [hideLabel]="true"
                                                    [(Documents)]="contract.Documents"
                                                    [permissions]="permissions.documentPermissions"
                                                    [DocumentTypeTargets]="documentTypeTargets"
                                                ></document-manager-old>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (contractCustomFieldsFormGroup) {
                            <div class="detail-page-card">
                                <div class="detail-page-card-title">{{ "contract.customFieldsTitle" | t }}</div>
                                <div
                                    class="detail-page-card-body padded form-group-styling cerrix-control-sm"
                                >
                                    <cerrix-custom-fields-editor
                                        [parentForm]="contractCustomFieldsFormGroup"
                                        [customFieldData]="customFieldData"
                                        [singleColumn]="false"
                                    ></cerrix-custom-fields-editor>
                                </div>
                            </div>
                        }
                    </div>
                    @if (contract.guid) {
                        <div
                            menuItemId="history"
                            [attr.name]="'contract.menuHistory' | t"
                            menuicon="fas fa-history"
                            menusystemitem
                        >
                            <app-history-overview
                                [Id]="contract.guid"
                                [historyDataService]="_contractDS"
                                #historyDetailOverviewComponent
                            ></app-history-overview>
                        </div>
                        <div
                            menuItemId="menuItemOptions"
                            [attr.name]="'contract.menuOptions' | t"
                            menuicon="fas fa-check-double"
                            menusystemitem
                        >
                            <detail-options
                                [moduleName]="'contract.optionsModuleName' | t"
                                [objectName]="contract ? contract.ContractNumber : 'contract'"
                                [allowDelete]="permissions.canDelete"
                                (onDelete)="delete()"
                            >
                            </detail-options>
                        </div>
                    }
                </div>
            </div>
        </form>
    </div>
}
